import { validationMixin } from 'vuelidate';
import { required, maxLength, email, requiredIf } from 'vuelidate/lib/validators';

export default {
    mixins: [validationMixin],

    validations: {
        checkboxNoTraces : {
            required : requiredIf(function (model) {
                if (this.checkboxProductTraces.length > 0 || this.othersProductTraces.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }),
        },
        checkboxProductTraces : {
            required : requiredIf(function (model) {
                if (this.othersProductTraces.length > 0 || this.checkboxNoTraces || this.checkboxProductTraces.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }),
        },
        othersProductTraces    : {
            required : requiredIf(function (model) {
                if (this.checkboxProductTraces.length > 0 || this.checkboxNoTraces || this.othersProductTraces.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }),
            maxLength : maxLength(50)
        },
        productTraces         : [
            'checkboxNoTraces',
            'checkboxProductTraces',
            'othersProductTraces'
        ]

    },
    props: {
        productTraces       :  {
            type    : Array,
            default : function () { return []; }
        },
        jsonDebug   :  {
            type    : Boolean,
            default : true
        },
    },
    data () {
        return {
            selectedProductInfos    : [],
            checkboxProductTraces   : [],
            othersProductTraces     : "",
            checkboxNoTraces        : false,
        };
    },
    watch: {
        productTraces(traces) {
            console.info('watch', traces);
        },
    },
    methods : {
        resetValues() {
            console.info('reset values');
            // this.selectedProductInfos   = [];
            // this.$refs.fieldSerialNumber.resetValue();
        },
        getValues() {
            let ret = {};
            // ret.swapProductInventoryNumber  = this.productInfos.inventorynumber;
            // ret.swapProductEanNumber        = this.productInfos.eannumber;
            // ret.swapProductBrandName        = this.productInfos.brandName;
            // ret.swapProductName             = this.productInfos.name[this.$i18n.locale];
            // ret.swapProductSerialNumber     = this.$refs.fieldSerialNumber.getValue();
            //
            // console.warn('values', ret);

            return ret;
        },
        onCheckboxNoTracesChange() {
            this.validateStep();
            this.checkboxProductTraces  = [];
            this.othersProductTraces    = "";
        },
        validateAll() {
            this.$v.productTraces.$touch();
            console.info('valdiate all product traces', this.$v);
            // if(!this.$v.productTraces.$dirty) {
            //     console.info('isDirty');
            //     return;
            // } else {
            //     console.info('is not Dirty');
            //     this.$v.productTraces.$touch();
            // }

        },
    },
    watch: {
        '$v.productTraces.$anyError' : function(errors) {
            if (errors) {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing xxx
                this.$emit('product-traces-has-errors');
            } else {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('product-traces-data-is-valid');

            }
        },
        '$v.productTraces.$dirty' : function(dirty) {
            if (!dirty && !this.$v.productTraces.$anyError) {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('product-traces-data-is-valid');
            } else {
                if (this.$v.stepProductData.$anyError) {
                    // Fire when the form is cleared
                    // @arg The argument is a boolean value representing xxx
                    this.$emit('product-traces-has-errors');
                }
            }
        }
    },
    computed: {
        checkboxNoTracesErrors () {
            const errors = [];
            if (!this.$v.checkboxNoTraces.$dirty) {
                return errors;
            }
            // !this.$v.checkboxNoTraces.required && errors.push('checkboxNoTraces is required.')
            if(!this.$v.checkboxNoTraces.required) {
                errors.push('checkboxNoTraces is required.');
            }
            return errors;
        },
        checkboxProductTracesErrors () {
            const errors = [];
            if (!this.$v.checkboxProductTraces.$dirty) {
                return errors;
            }
            // !this.$v.checkboxProductTraces.length > 0 && errors.push('checkboxProductTraces At least one item should be selected!')
            if(!this.$v.checkboxProductTraces.required) {
                errors.push('checkboxProductTraces is required.');
            }
            return errors;
        },
        othersProductTracesErrors () {
            const errors = [];
            if (!this.$v.othersProductTraces.$dirty) {
                return errors;
            }
            if(!this.$v.othersProductTraces.maxLength) {
                errors.push('othersProductTraces must be at most 50 characters long');
            }
            if(!this.$v.othersProductTraces.required) {
                errors.push('othersProductTraces is required.');
            }
            return errors;
        },
    },

};
